import { ApiStatus } from 'Enums';
import { returnUserInfos, urls } from 'Utilities/dataHelpers';
import log from 'Utilities/log';
import mediator from 'Utilities/mediator';
export const getConnectionsService = () => {
  const {
    xUserAgent,
    accountId
  } = returnUserInfos();
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: 'GET',
      url: urls.libreApiCountryUrl + `v1/patients/${accountId}/connections`,
      headers: {
        'X-User-Agent': xUserAgent
      },
      name: 'getConnections'
    }).then(result => {
      if (result.data) {
        resolve(result.data);
        return;
      }
      reject(result);
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
export const deleteCaregiverInvitationService = invitationId => {
  const {
    xUserAgent,
    accountId
  } = returnUserInfos();
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: 'DELETE',
      url: urls.libreApiCountryUrl + `v1/patients/${accountId}/connections/caregivers/invitations/${invitationId}`,
      headers: {
        'X-User-Agent': xUserAgent
      }
    }).then(result => {
      if (result.status === ApiStatus.NO_CONTENT) {
        resolve();
        return;
      }
      reject(result);
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
export const resendCaregiverInviteService = invitationId => {
  const {
    xUserAgent,
    accountId
  } = returnUserInfos();
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: 'POST',
      url: urls.libreApiCountryUrl + `v1/patients/${accountId}/connections/caregivers/invitations/${invitationId}`,
      headers: {
        'X-User-Agent': xUserAgent
      }
    }).then(result => {
      if (result.status === ApiStatus.NO_CONTENT) {
        resolve();
        return;
      }
      reject(result);
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
export const deleteCaregiverConnectionService = caregiverID => {
  const {
    xUserAgent,
    accountId
  } = returnUserInfos();
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: 'DELETE',
      url: urls.libreApiCountryUrl + `v1/patients/${accountId}/connections/caregivers/${caregiverID}`,
      headers: {
        'X-User-Agent': xUserAgent
      }
    }).then(result => {
      if (result.status === ApiStatus.NO_CONTENT) {
        resolve();
        return;
      }
      reject(result);
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
export const inviteCaregiverService = ({
  email,
  firstName,
  lastName
}) => {
  return new Promise((resolve, reject) => {
    const {
      xUserAgent,
      accountId
    } = returnUserInfos();
    mediator.request('api:invoke', {
      method: 'POST',
      url: urls.libreApiCountryUrl + `v1/patients/${accountId}/connections/caregivers/invitations`,
      headers: {
        'X-User-Agent': xUserAgent
      },
      data: {
        email,
        firstName,
        lastName
      }
    }).then(result => {
      if (result.data) {
        resolve(result.data);
        return;
      }
      reject(result);
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
export const acceptOrRejectPracticeInvitationService = ({
  invitationID,
  action
}) => {
  const {
    xUserAgent,
    accountId
  } = returnUserInfos();
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: 'POST',
      url: urls.libreApiCountryUrl + `v1/patients/${accountId}/connections/practices/invitations/${invitationID}`,
      headers: {
        'X-User-Agent': xUserAgent
      },
      data: {
        action
      }
    }).then(result => {
      if (result.status === ApiStatus.OK && result.data) {
        resolve(result.data);
        return;
      }
      if (result.status === ApiStatus.NO_CONTENT) {
        resolve();
        return;
      }
      reject(result);
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
export const validatePracticeService = businessID => {
  const {
    xUserAgent,
    accountId
  } = returnUserInfos();
  return new Promise((resolve, reject) => {
    const headers = {
      'X-User-Agent': xUserAgent
    };
    const baseUrl = urls.libreApiCountryUrl + `v1/patients/${accountId}/connections/practices`;
    mediator.request('api:invoke', {
      method: 'POST',
      url: baseUrl,
      headers,
      data: {
        businessID
      }
    }).then(result => {
      if (result.data) {
        resolve(result.data);
        return;
      }
      reject(result);
    }).catch(err => {
      const error = err;

      // To ensure backwards compatibility, we need to use the GET method as fallback. This logic will be removed in 3.27 release.
      if (error.status === 404 && error.response?.data?.message === 'Not Found') {
        const encodedBusinessID = encodeURIComponent(businessID);
        return mediator.request('api:invoke', {
          method: 'GET',
          url: baseUrl + `/${encodedBusinessID}`,
          headers
        }).then(result => {
          if (result.data) {
            resolve(result.data);
            return;
          }
          reject(result);
        }).catch(getErr => {
          log.error(getErr);
          reject(getErr);
        });
      }
      log.error(err);
      reject(err);
    });
  });
};
export const addPracticeService = practiceID => {
  const {
    xUserAgent,
    accountId
  } = returnUserInfos();
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: 'POST',
      url: urls.libreApiCountryUrl + `v1/patients/${accountId}/connections/practices/${practiceID}`,
      headers: {
        'X-User-Agent': xUserAgent
      }
    }).then(result => {
      if (result.data) {
        resolve(result.data);
        return;
      }
      reject(result);
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
export const removePracticeService = practiceID => {
  return new Promise((resolve, reject) => {
    const {
      xUserAgent,
      accountId
    } = returnUserInfos();
    mediator.request('api:invoke', {
      method: 'DELETE',
      url: urls.libreApiCountryUrl + `v1/patients/${accountId}/connections/practices/${practiceID}`,
      headers: {
        'X-User-Agent': xUserAgent
      }
    }).then(result => {
      if (result.status === ApiStatus.OK) {
        resolve();
        return;
      }
      reject(result);
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
export const removePartnerService = partnerID => {
  const {
    xUserAgent,
    accountId
  } = returnUserInfos();
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: 'DELETE',
      url: urls.libreApiCountryUrl + `v1/patients/${accountId}/connections/partners/${partnerID}`,
      headers: {
        'X-User-Agent': xUserAgent
      }
    }).then(result => {
      if (result.status === ApiStatus.NO_CONTENT) {
        resolve();
        return;
      }
      reject(result);
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
export const createNewDataShareService = () => {
  return new Promise((resolve, reject) => {
    const {
      xUserAgent,
      accountId
    } = returnUserInfos();
    mediator.request('api:invoke', {
      method: 'POST',
      url: urls.libreApiCountryUrl + `v1/patients/${accountId}/connections/data-share`,
      headers: {
        'X-User-Agent': xUserAgent
      }
    }).then(result => {
      if (result.data) {
        resolve(result.data);
        return;
      }
      reject(result);
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
export const stopDataShareService = () => {
  const {
    xUserAgent,
    accountId
  } = returnUserInfos();
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: 'DELETE',
      url: urls.libreApiCountryUrl + `v1/patients/${accountId}/connections/data-share`,
      headers: {
        'X-User-Agent': xUserAgent
      }
    }).then(result => {
      if (result.status === ApiStatus.OK) {
        resolve();
        return;
      }
      reject(result);
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
export const sharingCodeValidateService = ({
  code,
  yearOfBirth
}) => {
  const {
    xUserAgent,
    accountId
  } = returnUserInfos();
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: 'POST',
      url: urls.libreApiCountryUrl + `v1/patients/${accountId}/connections/partners/sharing-code/validate`,
      headers: {
        'X-User-Agent': xUserAgent
      },
      data: {
        code,
        yearOfBirth
      }
    }).then(result => {
      if (result.data) {
        resolve(result.data);
        return;
      }
      reject(result);
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
export const acceptOrRejectPartnerConnectionService = ({
  action,
  code,
  partnerID,
  yearOfBirth
}) => {
  const {
    xUserAgent,
    accountId
  } = returnUserInfos();
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: 'POST',
      url: urls.libreApiCountryUrl + `v1/patients/${accountId}/connections/partners/${partnerID}`,
      headers: {
        'X-User-Agent': xUserAgent
      },
      data: {
        action,
        code,
        yearOfBirth
      }
    }).then(result => {
      if (result.status === ApiStatus.OK && result.data) {
        resolve(result.data);
        return;
      }
      if (result.status === ApiStatus.NO_CONTENT) {
        resolve();
        return;
      }
      reject(result);
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
export const getPatientService = ({
  authToken,
  patientId,
  xUserAgent
}) => {
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: 'GET',
      url: urls.libreApiCountryUrl + 'v1/patients/' + patientId,
      headers: {
        'X-User-Agent': xUserAgent,
        Authorization: `Bearer ${authToken}`
      },
      name: 'getPatient'
    }).then(result => {
      if (result.data) {
        return resolve(result.data);
      }
      reject(result);
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
export const getLibreConfigService = ({
  country,
  xUserAgent
}) => {
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: 'GET',
      url: urls.libreApiCountryUrl + 'v1/config',
      headers: {
        'X-User-Agent': xUserAgent
      },
      params: {
        country,
        compatibility: false
      }
    }).then(result => {
      if (result.data) {
        return resolve(result.data);
      }
      reject(result);
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
export const acceptHealthDataScope = ({
  partnerID
}) => {
  return _submitHealthDataScopeDecision({
    partnerID,
    isAccepted: true
  });
};
export const declineHealthDataScope = ({
  partnerID
}) => {
  return _submitHealthDataScopeDecision({
    partnerID,
    isAccepted: false
  });
};
const _submitHealthDataScopeDecision = ({
  partnerID,
  isAccepted
}) => {
  const {
    xUserAgent,
    accountId
  } = returnUserInfos();
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: isAccepted ? 'POST' : 'DELETE',
      url: urls.libreApiCountryUrl + `v1/patients/${accountId}/connections/partners/${partnerID}/health-scope`,
      headers: {
        'X-User-Agent': xUserAgent
      }
    }).then(result => {
      if (result.status === ApiStatus.OK && result.data) {
        resolve(result.data);
        return;
      }
      if (result.status === ApiStatus.NO_CONTENT) {
        resolve();
        return;
      }
      reject(result);
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};